import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import pick from './utilities/pick'
import mapDispatchers from './utilities/mapDispatchers'
import getStartLocationForUser from './utilities/getStartLocationForUser'
import styles from './Verify.icss'
import FacebookAuthButton from './components/FacebookAuthButton'
import InstagramAuthButton from './components/InstagramAuthButton'
import EmailAuthButton from './components/EmailAuthButton'
import Img from './components/Img'

const defaultImageSrc = '/images/icons/white/profile.svg'

class Verify extends React.Component {
	static getDerivedStateFromProps(props) {
		const userName = props && props.match && props.match.params ?
			props.match.params.username :
			null

		return { userName }
	}

	constructor(props) {
		super(props)

		this.state = {
			imgStyle: {
				backgroundImage: `url(${defaultImageSrc})`
			}
		}

		this.setBackgroundImage = this.setBackgroundImage.bind(this)
	}

	componentDidMount() {
		this.props.appBackButtonFunction(false)
		this.props.appShowTopBar(false)
		this.props.appShowBottomBar(false)
		if (this.state.userName) {
			this.props.verifyUserSetToLocalstorage({ userName: this.state.userName })
			this.props.userProfilePublicFetch(this.state.userName)
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if ((this.props.authFacebookLoginSuccess || this.props.authInstagramLoginSuccess) &&
			!this.props.user.isAnonymous && !this.props.user.isLoading) {
			this.props.appRedirect(getStartLocationForUser(this.props.user))
			return
		}

		if (prevState.userName !== this.state.userName) {
			this.props.userProfilePublicFetch(this.state.userName)
		}

		const up = this.props.userProfilePublic
		if (up) {
			if (up !== prevProps.userProfilePublic) {
				this.props.verifyUserSetToLocalstorage({ userName: up.userName, realName: up.realName })
				this.setBackgroundImage()
			}
			if ((this.props.userProfilePublicVerifiers || []).some(pp => pp.uid === up.uid)) {
				this.props.authAlreadyVerified()
				this.props.appRedirect(getStartLocationForUser(this.props.user, true))
			}
		} else {
			this.props.verifyUserRemoveFromLocalstorage()
		}
	}

	componentWillUnmount() {
		this.props.authReset()
	}

	setBackgroundImage() {
		const up = this.props.userProfilePublic
		let imgSrc = defaultImageSrc

		if (up && up.images && up.images.length) {
			//	Get background image from profile
			const image = up.images.find(i => i.type === 'half') || up.images[0]
			if (image && image.url) {
				imgSrc = image.url
			}
		}
		const backgroundImage = `url(${imgSrc})`

		if (this.state.imgStyle.backgroundImage !== backgroundImage) {
			this.setState({ imgStyle: { backgroundImage } })
		}
	}

	render() {
		return (
			<div className={styles.verifyWrapper}>
				<section className={styles.welcomeWrapperVerify}>
					<h2><Img className={styles.logo} content="/images/logo/kitfit-logo-white.svg" /></h2>
					<p className={styles.welcomeParagraph}>
						{!this.props.userPublicNameNotFound && (
							<span>
								<span className={styles.dampenText}>{this.context.translate('Verify ')}</span>
								<b>{this.state.userName}</b>
							</span>
						)}
						{this.props.userPublicNameNotFound && (
							<span>
								<span className={styles.dampenText}>{this.context.translate('user {userName} not found', this.state)}</span>
							</span>
						)}
					</p>
				</section>
				<section className={styles.imageWrapperVerify}>
					<div className={styles.img} style={this.state.imgStyle} />
					<div className={styles.imageShadowTop} />
					<div className={styles.imageShadowBottom} />
					<p className={styles.postParagraph}>
						<span>
							<b>{this.context.translate('Get ')}</b>
							<span className={styles.dampenText}>{this.context.translate('what you ')}</span>
							<b>{this.context.translate('Give')}</b>
						</span>
					</p>
				</section>
				<section className={styles.actionsWrapper}>
					<div className={styles.buttonWrapper}>
						<InstagramAuthButton />
						<FacebookAuthButton />
						<EmailAuthButton />
					</div>
				</section>
			</div>
		)
	}
}

Verify.contextTypes = {
	translate: PropTypes.func
}

Verify.propTypes = {
	appBackButtonFunction: PropTypes.func.isRequired,
	appShowTopBar: PropTypes.func.isRequired,
	appShowBottomBar: PropTypes.func.isRequired,
	appRedirect: PropTypes.func.isRequired,
	authReset: PropTypes.func.isRequired,
	authFacebookLoginSuccess: PropTypes.bool,
	authInstagramLoginSuccess: PropTypes.bool,
	authAlreadyVerified: PropTypes.func.isRequired,
	userProfilePublicFetch: PropTypes.func.isRequired,
	userProfilePublic: PropTypes.object, // eslint-disable-line react/forbid-prop-types
	userProfilePublicVerifiers: PropTypes.array, // eslint-disable-line react/forbid-prop-types
	userPublicNameNotFound: PropTypes.bool,
	verifyUserSetToLocalstorage: PropTypes.func.isRequired,
	verifyUserRemoveFromLocalstorage: PropTypes.func.isRequired,
	user: PropTypes.object, // eslint-disable-line react/forbid-prop-types
	match: PropTypes.shape({
		params: PropTypes.object.isRequired
	}).isRequired
}

Verify.defaultProps = {
	authFacebookLoginSuccess: false,
	authInstagramLoginSuccess: false,
	user: undefined,
	userPublicNameNotFound: false,
	userProfilePublic: undefined,
	userProfilePublicVerifiers: undefined
}

export const testing = {
	Verify
}

export default connect(
	/* istanbul ignore next line */
	state => pick(state, ['user', 'userProfilePublic', 'authFacebookLoginSuccess', 'authInstagramLoginSuccess', 'userPublicNameNotFound']),
	/* istanbul ignore next line */
	dispatch => mapDispatchers(dispatch, ['appBackButtonFunction', 'appShowTopBar', 'appShowBottomBar', 'appRedirect', 'authReset', 'authAlreadyVerified', 'userProfilePublicFetch', 'verifyUserSetToLocalstorage', 'verifyUserRemoveFromLocalstorage'])
)(Verify)



// WEBPACK FOOTER //
// ./src/Verify.jsx